import InfoCard from 'components/InfoCard';
import JobFinanceApplicationProgressCard from './Card';
import useJobFinanceApplicationProgress from './useJobFinanceApplicationProgress';

const JobFinanceApplicationProgress: React.FunctionComponent = function ({}) {
  const { isLoading, showStatus } = useJobFinanceApplicationProgress();
  if (!showStatus) return null;
  return (
    <InfoCard title="Finance Application" isLoading={isLoading}>
      <JobFinanceApplicationProgressCard isLoading={isLoading} />
    </InfoCard>
  );
};

export default JobFinanceApplicationProgress;
